<mat-toolbar class="subtitulo">Home</mat-toolbar>

<div fxLayout="row" fxLayoutAlign="center center" style="height: 500px;">
   <img [src]="getBackground()" class="imagem"/>
</div>

